import React, {Component} from "react";
import TeamImg1 from "../../../images/User/avatar-male-1.jpg";
import TeamImg2 from "../../../images/User/avatar-male-2.jpg";
import TeamImg3 from "../../../images/User/avatar-girl-2.jpg";

class Team extends Component{

    constructor(props){
        super(props);
        this.state = {
            style : {
                textAlign : "center",
                margin : "4rem 0",
            }
        }
    }

    render(){
        return(
            <div className="breadcrumb-area">
                <h2 style={this.state.style}>The Team</h2>
                <div className="architecure-widget">
                    <div className="architecture-flex">
                        <div className="team-member-card">
                            <img src={TeamImg1} />
                            <h4>Daniel Adewale</h4>
                            <p className="small-txt">Front End Developer, UI/UX Designer</p>
                            <div className="social-flex team-social">
                                <i className="fab fa-linkedin"></i>
                                <i className="fab fa-facebook-square"></i>
                            </div>
                        </div>
                        <div className="team-member-card">
                            <img src={TeamImg2} />
                            <h4>Daniel Adewale</h4>
                            <p className="small-txt">Front End Developer, UI/UX Designer</p>
                            <div className="social-flex team-social">
                                <i className="fab fa-linkedin"></i>
                                <i className="fab fa-facebook-square"></i>
                            </div>
                        </div>
                    </div>
                    <div className="architecture-flex">
                        <div className="team-member-card">
                            <img src={TeamImg3} />
                            <h4>Daniel Adewale</h4>
                            <p className="small-txt">Front End Developer, UI/UX Designer</p>
                            <div className="social-flex team-social">
                                <i className="fab fa-linkedin"></i>
                                <i className="fab fa-facebook-square"></i>
                            </div>
                        </div>
                    </div>
                    <div className="architecture-flex">
                        <div className="team-member-card">
                            <img src={TeamImg1} />
                            <h4>Daniel Adewale</h4>
                            <p className="small-txt">Front End Developer, UI/UX Designer</p>
                            <div className="social-flex team-social">
                                <i className="fab fa-linkedin"></i>
                                <i className="fab fa-facebook-square"></i>
                            </div>
                        </div>
                        <div className="team-member-card">
                            <img src={TeamImg2} />
                            <h4>Daniel Adewale</h4>
                            <p className="small-txt">Front End Developer, UI/UX Designer</p>
                            <div className="social-flex team-social">
                                <i className="fab fa-linkedin"></i>
                                <i className="fab fa-facebook-square"></i>
                            </div>
                        </div>
                    </div>
                    <div className="architecture-flex">
                        
                    </div>
                </div>
            </div>
        );
    }
}

export default Team;

